import React from 'react';

import './style.scss';
import MenuManager from '../Menu/MenuManager';
import Header from '../Header';
import ContactButton from '../ContactButton';

const Gallery = ({ children }) => {
    return (
        <>
            <MenuManager>
                <Header />
                <div className={'contact-button-container'}>
                    <ContactButton />
                </div>    
                {children}
            </MenuManager>
        </>
    )
};

export default Gallery;